import { TimelineStore } from "../../store/TimelineStore";
import {TIMELINE_RULER_TICK_WIDTH_PX} from "../../config/config";
import {SequenceTimelineStore} from "../../../sequenceEditor/store/SequenceTimelineStore";

export function convertTimeToUnits(time: number, isSequence: boolean = false): number {
  const timelineZoom = isSequence ? SequenceTimelineStore.zoom : TimelineStore.zoom;

  const ratio = TIMELINE_RULER_TICK_WIDTH_PX * timelineZoom;
  return time * ratio;
}

/**
 * Convert an absolute timeline time (seconds from composition start) to x-position in pixels
 * within the TRACK CONTENT coordinate system (i.e. after the left pad).
 *
 * When timeline virtualization is active, x=0 represents TimelineStore.baseStartSec.
 */
export function convertAbsTimeToUnits(timeSec: number, isSequence: boolean = false): number {
  if (isSequence) return convertTimeToUnits(timeSec, true);
  const pxPerSec = TIMELINE_RULER_TICK_WIDTH_PX * TimelineStore.zoom;
  const baseStartSec = TimelineStore.baseStartSec ?? 0;
  return (timeSec - baseStartSec) * pxPerSec;
}
